import { render } from "./message-emoji-react.vue?vue&type=template&id=3266b21c&scoped=true&ts=true"
import script from "./message-emoji-react.vue?vue&type=script&lang=ts"
export * from "./message-emoji-react.vue?vue&type=script&lang=ts"

import "./message-emoji-react.vue?vue&type=style&index=0&id=3266b21c&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3266b21c"]])

export default __exports__